<template>
    <modal id="kpi-detail-modal"
           size="extra-large"
           v-model="showModal"
           :title="title || $t('details')"
           :cancel-btn-label="$t('close')"
           :hide-submit-button="true"
           @submit=""
           :preloader="preloader">

        <div class="position-relative" style="min-height: 120px;">
            <div v-if="rows.length" class="kpi-detail-table-wrapper">
                <table class="table table-borderless mb-0">
                    <thead>
                    <tr>
                        <th v-for="col in columns" :key="col.key"
                            :class="{ 'text-right': col.key === 'value' || col.key === 'members' || col.key === 'years' }">
                            {{ col.label }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                        <td v-for="col in columns" :key="col.key"
                            :class="{ 'text-right': col.key === 'value' || col.key === 'members' || col.key === 'years' }">
                            <span v-if="col.key === 'name'" class="font-weight-500">{{ row[col.key] }}</span>
                            <span v-else-if="col.key === 'type'" class="badge"
                                  :class="row[col.key] === 'Leave' ? 'badge-info' : 'badge-warning'">{{ row[col.key] }}</span>
                            <span v-else-if="col.key === 'status'" class="badge badge-warning">{{ row[col.key] }}</span>
                            <span v-else>{{ row[col.key] }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-else-if="!preloader" class="text-center text-muted py-5">
                {{ $t('no_data_found') }}
            </div>

            <div v-if="total > perPage" class="mt-3">
                <app-pagination :total-row="total" :row-limit="perPage" @submit="goToPage"/>
            </div>
        </div>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD} from "../../../../Config/ApiUrl";
import {localTimeZone} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "KpiDetailModal",
    mixins: [ModalMixin],
    props: {
        kpiKey: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            title: '',
            columns: [],
            rows: [],
            total: 0,
            perPage: 10,
        }
    },
    created() {
        this.fetchDetails(1);
    },
    methods: {
        fetchDetails(page) {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/kpi-details?key=${this.kpiKey}&page=${page}&per_page=${this.perPage}&time_zone=${encodeURIComponent(localTimeZone)}`)
                .then(({data}) => {
                    this.title = data.title;
                    this.columns = data.columns || [];
                    this.rows = (data.result && data.result.data) ? data.result.data : [];
                    this.total = (data.result && data.result.total) ? data.result.total : 0;
                    this.perPage = (data.result && data.result.per_page) ? data.result.per_page : this.perPage;
                }).finally(() => {
                this.preloader = false;
            })
        },
        goToPage(page) {
            this.fetchDetails(page);
        }
    }
}
</script>

<style scoped>
.kpi-detail-table-wrapper {
    max-height: 55vh;
    overflow-y: auto;
}

.kpi-detail-table-wrapper th {
    position: sticky;
    top: 0;
    background: var(--default-card-bg);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--default-secondary-color, #7b8398);
    border-bottom: 2px solid var(--default-border-color);
    padding: 10px 12px;
}

.kpi-detail-table-wrapper td {
    font-size: 13px;
    padding: 11px 12px;
    border-bottom: 1px solid var(--default-border-color);
    vertical-align: middle;
}

.font-weight-500 {
    font-weight: 500;
}
</style>
